import { ControlledObservationFormFields, IAuditNote, IAuditNoteFormData, TEditableAuditNote } from "../interfaces/IAuditNote";

const AuditNoteMapper = {
    domainToFormData: (domain: IAuditNote): IAuditNoteFormData => ({
        otsikko: domain.title,
        kuvaus: domain.details,
        makeObservation: Boolean(domain.relatedObservation),

        sijainti: domain.target,
        ilmottaja: domain.creator,
        tapahtuma_aika: domain.eventTime,
        kuvat: domain.images,
        //  kuva: domain.images,
    }),



    editableNoteToMetaData: (note: TEditableAuditNote): Pick<IAuditNote, "title" | "details" | "images"> => {
        if (note.unsubmitted || note.submitStatus !== "submitted") {
            let formData = note.formData || {};
            return {
                title: formData[ControlledObservationFormFields.title] || "",
                details: formData[ControlledObservationFormFields.details] || "",
                images: formData[ControlledObservationFormFields.images],
            };
        };
        const { title, details, images } = note
        return { title, details, images };
    }

};

export default AuditNoteMapper
